import React, { useState } from "react";

import Button from "src/components/Button/Button";
import Dropdown, { IOption } from "src/components/Dropdown/Dropdown";
import Input from "src/components/Input/Input";

import styles from "../JudgeScheduleBuilder.module.scss";

const BREAK_LENGTHS = [5, 10, 15, 20, 30, 45, 60, 90, 120];

function breakLengthOptions(current?: number): IOption[] {
  const minutes = new Set(BREAK_LENGTHS);
  if (current && current > 0) minutes.add(Math.round(current));
  return Array.from(minutes).sort((a, b) => a - b).map((length) => ({ id: String(length), value: `${length} Minutes` }));
}

interface IProps {
  title: string;
  initialName?: string;
  initialDuration?: number;
  /** Name can't be changed (UKC Conformation BIS blocks); only the length is editable. */
  fixedName?: boolean;
  /** UKC Conformation BIS blocks the club removed from this show; each can be put back here. */
  restoreOptions?: string[];
  onRestore?: (bisClass: string) => void;
  onCancel: () => void;
  onSubmit: (name: string, duration: number) => void;
}

const BreakForm: React.FC<IProps> = ({ title, initialName = "Break", initialDuration = 60, fixedName = false, restoreOptions = [], onRestore, onCancel, onSubmit }) => {
  const options = breakLengthOptions(initialDuration);
  const [name, setName] = useState(initialName);
  const [duration, setDuration] = useState<IOption>(
    options.find((option) => option.id === String(Math.round(initialDuration))) || options[options.length - 1]
  );

  return (
    <div className={styles.form}>
      <h3>{title}</h3>
      <div className={styles.breakFields}>
        {!fixedName && <Input
          label="Break name"
          placeholder="Break name"
          defaultValue={name}
          onChange={(event) => setName(event.target.value)}
        />}
        <Dropdown
          label={fixedName ? "Duration" : "Break Length"}
          placeholder=""
          options={options}
          value={duration}
          onChange={(_event, value) => setDuration(value)}
        />
      </div>
      {restoreOptions.length > 0 && onRestore && (
        <div className={styles.breakFields}>
          <p>Removed from this show. Add back here:</p>
          {restoreOptions.map((bisClass) => (
            <Button key={bisClass} variant="secondary" onClick={() => onRestore(bisClass)}>Add {bisClass}</Button>
          ))}
        </div>
      )}
      <div className={styles.formActions}>
        <Button variant="secondary" onClick={onCancel}>Cancel</Button>
        <Button onClick={() => onSubmit(name.trim() || "Break", Number(duration.id))}>Save</Button>
      </div>
    </div>
  );
};

export default BreakForm;
